module.exports = __webpack_public_path__ + "static/media/yen-sign.e760b300.svg";